// extracted by mini-css-extract-plugin
module.exports = {"component":"style_component__f659f","header":"style_header__a3UgD","footer":"style_footer__HeFhn","stay":"style_stay___HWh5"};